/**
 * Container Entity Configuration
 *
 * @version 1.0
 * @module core/modules/waste/config
 *
 * @description
 * Configuración de la entidad "Contenedor" para el entity registry.
 * Define API, UI, factory y metadatos para contenedores de residuos.
 */

import { Trash2 } from 'lucide-react';
import type { EntityConfig } from '../../../entity-registry';
import type { Container } from '../../../map-tools/MapToolsContext';
import { ContainerDetailsPanel } from '../../../map-tools/ContainerDetailsPanel';
// TODO: Crear containersApi cuando se implemente
// import { containersApi } from '../api/containers-api';

/**
 * Crea un contenedor con valores por defecto
 */
function createDefaultContainer(coordinates: [number, number]): Container {
  const timestamp = Date.now();
  const randomSuffix = Math.random().toString(36).substring(2, 15);

  return {
    id: `container-${timestamp}-${randomSuffix}`,
    code: `TEMP-CONTAINER-${timestamp}`,
    coordinates,
    containerType: 'general',
    capacity: 1100, // litros (default: contenedor estándar)
    currentFill: 0,
    status: 'active',
    createdAt: new Date(),
    updatedAt: new Date(),
  };
}

/**
 * API service placeholder
 * TODO: Reemplazar con containersApi real cuando se implemente
 */
const containerApiPlaceholder = {
  create: async (data: Partial<Container>): Promise<Container> => {
    console.warn('[ContainerEntity] API create no implementada aún');
    return { ...data, id: data.id || `container-${Date.now()}` } as Container;
  },
  update: async (_id: string, data: Partial<Container>): Promise<Container> => {
    console.warn('[ContainerEntity] API update no implementada aún');
    return { ...data, id: _id } as Container;
  },
  delete: async (): Promise<void> => {
    console.warn('[ContainerEntity] API delete no implementada aún');
  },
};

/**
 * Configuración de la entidad "Contenedor"
 */
export const containerEntityConfig: EntityConfig<Container> = {
  type: 'container',
  displayName: 'contenedor',
  toolId: 'add-container',

  apiService: containerApiPlaceholder,

  detailsPanel: ContainerDetailsPanel,
  icon: Trash2,

  createDefault: createDefaultContainer,
  tempIdPrefix: 'container-',
  codePrefix: 'CT',

  // Funciones extractoras
  getId: (container) => container.id,
  getCoordinates: (container) => container.coordinates,
  getCode: (container) => container.code,
};
